import { useEffect, useState } from "react";
import { Outlet } from "@tanstack/react-router";
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";
import { ActiveProjectProvider } from "@/hooks/use-active-project";
import { ActiveClientProvider } from "@/hooks/use-active-client";
import { connectInboxWs, disconnectInboxWs } from "@/lib/ws";

export function AppShell() {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    connectInboxWs();
    return () => disconnectInboxWs();
  }, []);

  return (
    <ActiveProjectProvider>
    <ActiveClientProvider>
      <div className="min-h-screen flex bg-ink-50/60 dark:bg-ink-950">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
        <div className="flex-1 flex flex-col min-w-0">
          <Topbar />
          <main className="flex-1 min-w-0 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </ActiveClientProvider>
    </ActiveProjectProvider>
  );
}
